export default __webpack_public_path__ + "static/media/Banner_image_Werfkelder_small.3ccf5304.jpg";